import React, { useState } from 'react'
import { useHistory } from 'react-router-dom'
import { useDispatch } from 'react-redux'
import { addToSaleBag } from '../../../actions/inventoryActions'
import { Table } from '../../../admin/components/Table/Table'
import { Translate } from '../../../language'
import { SaleBag, SaleRegister } from '../../../assets/icons'
import TitleSVG from '../../../utils/components/TitleSVG/TitleSVG'
import plusCircle from '../../../assets/img/plusCircle.png'
import ButtonIcon from '../../../utils/components/ButtonIcon/ButtonIcon'
import buttonStyle from './SaleButtonStyle.module.css'
import style from './InventoryListForSale.module.css'




const InventoryListForSale = ({ products }) => {


    const dispatch = useDispatch();
    const history = useHistory();

    const [isVisibleIconCart, setisVisibleIconCart] = useState(false)


    const onClickAdd = (product) => {
        dispatch(addToSaleBag(product.productId, product.stocks));
        setisVisibleIconCart(true);
    }

    const onClickSaleCart = () => {
        history.push('/Inventory/SaleRegister/Cart');
    }

    return (
        <div>
            <TitleSVG Icon={SaleRegister} titleHighlight={Translate('registerText', 'es')} title={Translate('saleRegisterTitle', 'es')} />

            <Table style={style} >
                <thead>
                    <tr>
                        <th>Codigo</th>
                        <th>Producto</th>
                        <th>Cantidad</th>
                        <th>Agregar </th>
                    </tr>
                </thead>
                <tbody>
                    {
                        products.map(product => (
                            <tr key={product._id}>
                                <td>{product.productId.code}</td>
                                <td>{product.productId.name}</td>
                                <td>{product.stocks}</td>
                                <td className={`${style.add_button}`} >
                                    <img  className="animate__animated animate__bounceIn" onClick={() => { onClickAdd(product) }} src={plusCircle} height={30} alt="" />
                                </td>

                            </tr>
                        ))
                    }
                </tbody>
            </Table>

            <ButtonIcon
                onClick={onClickSaleCart}
                Icon={SaleBag}
                isIconCircle={true}
                text='Carrito de ventas'
                style={buttonStyle}
                isVisible={isVisibleIconCart}
                animation= "animate__animated animate__fadeIn"
                widthCircle="5vw"
                widthIcon="3vw"

            />
        </div>
    )
}

export default InventoryListForSale